import http from '../../Common/api';
import { payerDomain } from '../../Common/constants';

import { aggregatorsUrl, payersUrl, dropDownDefault } from './constants';
import { normalizeAggregators, normalizePayers, normalizeRequiredFields } from './normalizers';

const getAggregatorOptions = async () => {
  try {
    const aggregators = await http.get(aggregatorsUrl);

    return normalizeAggregators(aggregators);
  } catch (error) {
    return dropDownDefault;
  }
};

const getPayerOptions = async aggregatorID => {
  try {
    const payers = await http.get(`${payersUrl}${aggregatorID}/`);

    return normalizePayers(payers);
  } catch (error) {
    return [];
  }
};

const getRequiredFieldsReports = async ({ aggregatorID, payerID }) => {
  try {
    const state = aggregatorID.slice(0, 2);
    const requiredFieldsUrl = `${payerDomain}/required-visit-fields-for-payer/${state}/${payerID}/`;
    const response = await http.get(requiredFieldsUrl);

    return { requiredFields: normalizeRequiredFields(response.requiredFields), status: '' };
  } catch (error) {
    return { requiredFields: [], status: error.status };
  }
};

export { getAggregatorOptions, getPayerOptions, getRequiredFieldsReports };
